export default {
  titlePrefix: 'au portail ',
  UnifiTitle: 'Unifie',
  AcuraTitle: 'Acura',
  HondaTitle: 'Honda',
  HyundaiTitle: 'Hyundai',
  GenesisTitle: 'Genesis',
  ErrorTitle: 'Erreur technique',
  ErrorMessage: 'Nous sommes désolés des inconvénients que cela peut vous causer.',
  ErrorRetryButton: 'Réessayer',
  NotFoundTitle: 'Page introuvable',
  NotFoundMessage: 'Désolé, la page a été déplacée ou supprimée.',
  NotFoundBackButton: 'Retour',
  CopyrightUnifi: '™ {{year}} iA Groupe financier est une marque de commerce et un autre nom sous lequel l’Industrielle Alliance, Assurance et services financiers inc. exerce ses activités. Tous droits réservés.',
  CopyrightHyundai: '© {{year}} Hyundai Canada\nLes noms, logos, noms de produits, noms des caractéristiques, images et slogans Hyundai sont des marques de commerce appartenant à (ou utilisées sous licence par) Hyundai Auto Canada Corp.',
  CopyrightGenesis: 'MC/MD {{year}} Le nom Genesis ainsi que les logos, noms de produits, noms de fonctionnalités, images et slogans Genesis sont des marques appartenant à (ou utilisées sous licence par) Genesis Motors Canada, une division de Hyundai Auto Canada Corp.',
  CopyrightHonda: '© {{year}} Honda est une marque déposée de Honda Motor Co., Ltd. sous licence de Honda Canada Inc. Tous droits réservés.',
  CopyrightAcura: '© {{year}} Acura est une marque déposée de Honda Motor Co., Ltd. sous licence de Honda Canada Inc. Tous droits réservés.',
};
